import { setPropertyInterestType } from '@zillow/user-onboarding';

import type { ListingButtonConfig } from './ListingButtons';

export const BUYING_LISTING_BUTTON: ListingButtonConfig = {
    displayText: 'For sale',
    searchType: 'for_sale',
    trackingLabel: 'buying',
    // set 'buying' flag in localStorage before redirecting to search results
    preCallback: () => setPropertyInterestType('buying'),
};

export const RENTING_LISTING_BUTTON: ListingButtonConfig = {
    displayText: 'For rent',
    searchType: 'for_rent',
    trackingLabel: 'renting',
    // set 'renting' flag in localStorage before redirecting to search results
    preCallback: () => setPropertyInterestType('renting'),
};

export const SKIP_LISTING_BUTTON: ListingButtonConfig = {
    displayText: 'Skip this question',
    searchType: 'for_sale',
    trackingLabel: 'skip',
    // set 'buying-selling' flag in localStorage before redirecting to search results
    preCallback: () => setPropertyInterestType('none'),
};
